import { useState } from 'react';
import { INDUSTRY_DATA } from './utils/constants';
import {
  Screen1Welcome,
  Screen2Disclaimer,
  Screen3GetStarted,
  Screen4Form,
  Screen5Generating,
  Screen6ConflictingPriorities,
  Screen7ParadigmShifts,
  Screen8BusinessChallenges,
  Screen9BusinessValue,
  Screen10DecisionCriteria,
} from './components/Screens';
import { AppFooter } from './components/AppFooter';

const INDUSTRIES = INDUSTRY_DATA.map(item => item.Industry);

const App = () => {
  const [currentScreen, setCurrentScreen] = useState(1);
  const [formData, setFormData] = useState({
    customerName: '',
    executiveName: '',
    executiveTitle: '',
    primaryCompetitor: '',
    industry: '',
  });
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const totalScreens = 10;

  const handleNext = () => {
    if (currentScreen === 4) {
      const industry = INDUSTRY_DATA.find(item => item.Industry === formData.industry);
      setSelectedIndustry(industry);
    }
    if (currentScreen < totalScreens) {
      setCurrentScreen(currentScreen + 1);
    }
  };

  const handlePrev = () => {
    if (currentScreen > 1) {
      setCurrentScreen(currentScreen - 1);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const renderScreen = () => {
    const screenProps = {
      formData,
      selectedIndustry,
      onInputChange: handleInputChange,
      industries: INDUSTRIES,
    };

    switch (currentScreen) {
      case 1:
        return <Screen1Welcome {...screenProps} />;
      case 2:
        return <Screen2Disclaimer {...screenProps} />;
      case 3:
        return <Screen3GetStarted {...screenProps} />;
      case 4:
        return <Screen4Form {...screenProps} />;
      case 5:
        return <Screen5Generating {...screenProps} />;
      case 6:
        return <Screen6ConflictingPriorities {...screenProps} />;
      case 7:
        return <Screen7ParadigmShifts {...screenProps} />;
      case 8:
        return <Screen8BusinessChallenges {...screenProps} />;
      case 9:
        return <Screen9BusinessValue {...screenProps} />;
      case 10:
        return <Screen10DecisionCriteria {...screenProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full flex flex-col sm:items-center  bg-gradient-to-br h-screen from-purple-300 via-white to-green-50">
      <div className="flex-1  w-full max-w-xl  ">{renderScreen()}</div>

      <AppFooter currentScreen={currentScreen} totalScreens={totalScreens} onPrev={handlePrev} onNext={handleNext} formData={formData} />
    </div>
  );
};

export default App;
